import { IAppState } from '../../store';

export const selectErrorMessage = (state: IAppState) => state.personalLeadsForm.errorMessage;
